"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var deepmerge_1 = __importDefault(require("deepmerge"));
exports.collapseTheme = function (theme) {
    var componentTheme = {
        header: {
            backgroundColor: theme.greyNormal.color.normal,
            backgroundColorActive: theme.greyDark.color.normal,
            backgroundColorHover: theme.greyLight.color.normal,
            borderRadius: theme.global.borderRadius,
            border: 'none',
            borderActive: 'none',
            padding: '.25rem',
        },
        content: {
            padding: '.25rem',
        },
        font: {
            color: theme.base.color.text,
            size: '0.875rem',
        },
    };
    var cardstyleTheme = {
        header: {
            backgroundColor: theme.base.color.normal,
            backgroundColorActive: theme.base.color.normal,
            backgroundColorHover: theme.base.color.normal,
            borderRadius: '0',
            border: "3px solid " + theme.base.color.normal,
            borderActive: "3px solid " + theme.primary.color.normal,
            padding: '.5rem .25rem',
        },
        content: {
            padding: '.25rem',
        },
        font: {
            color: theme.base.color.text,
            size: '0.875rem',
        },
    };
    var finalTheme = {
        default: componentTheme,
        cardstyle: cardstyleTheme,
    };
    if (theme.component.collapse) {
        finalTheme = deepmerge_1.default(finalTheme, theme.component.collapse);
    }
    return __assign(__assign({}, theme), { component: __assign(__assign({}, theme.component), { collapse: finalTheme }) });
};
exports.default = exports.collapseTheme;
//# sourceMappingURL=theme.js.map